import { PaymentDto } from "./../dtos/paymentDto";
import { InvoiceManagementDto } from "./../dtos/invoiceManagementDto";
import { CustomerInfoDto } from "./../dtos/customerInfoDto";
import { ArticleDto } from "@/dtos/articleDto";
import { UserRightsDto } from "@/dtos/userRightsDto";
import { MatchingType } from "@/dtos/matchingType";

export default {
	// **********************************************************************
	// SYSTEM
	// **********************************************************************
	storeOidcUser(state: any, user: any) {
		state.oidc.user = user;
	},
	storeOidcInstance(state: any, client: any) {
		state.oidc.instance = client;
	},
	setIsAdmin(state: any, isAdmin: boolean) {
		state.isAdmin = isAdmin;
	},
	setSnackbarText(state: any, text: any) {
		state.snackbarColor = "accent";
		state.snackbarText = text;
	},
	setSnackbarErrorText(state: any, text: any) {
		state.snackbarColor = "red";
		state.snackbarText = text;
	},
	setUserRights(state: any, userRights: UserRightsDto) {
		state.userRights = userRights;
	},
	setEmbedded(state: any, embedded: boolean) {
		state.embedded = embedded;
	},
	setManufacturers(state: any, manufacturers: any) {
		state.fertigers = manufacturers;
	},

	// **********************************************************************
	// CUSTOMERS
	// **********************************************************************
	setCustomers(state: any, customers: any) {
		state.customers = customers;
	},
	addOrUpdateCustomers(state: any, customers: any) {
		// Add new customers that weren't in the list before
		// Replace already existing customers to keep them updated
		customers.forEach((c: any) => {
			const customerIndex = state.customers.findIndex(
				(stateCustomer: CustomerInfoDto) => stateCustomer.customerId == c.customerId
			);
			if (customerIndex >= 0) {
				state.customers.splice(customerIndex, 1, c);
			} else {
				state.customers.push(c);
			}
		});
	},
	/**
	 * Removes the customer with the specified id from the state if it is loaded.
	 * @param state
	 * @param customerId
	 */
	removeCustomer(state: any, customerId: any) {
		const customerIndex = state.customers.findIndex(
			(stateCustomer: CustomerInfoDto) => stateCustomer.customerId == customerId
		);
		if (customerIndex >= 0) {
			state.customers.splice(customerIndex, 1);
		}
	},
	markCustomerInactive(state: any, customerId: any) {
		const customerIndex = state.customers.findIndex(
			(stateCustomer: CustomerInfoDto) => stateCustomer.customerId == customerId
		);
		if (customerIndex >= 0) {
			state.customers[customerIndex].active = false;
		}
	},
	setTags(state: any, tags: any) {
		state.tags = tags;
	},
	setFilterTags(state: any, tags: any) {
		state.customerFilterTags = tags;
	},
	setCustomerFilterCountries(state: any, countries: any) {
		state.customerFilterCountries = countries;
	},
	setSuchbegriff(state: any, suchbegriff: any) {
		state.suchbegriff = suchbegriff;
	},
	setManualSkip(state: any, skip: number) {
		state.manualSkip = skip;
	},
	setCustomerSearchCountries(state: any, countries: any) {
		state.customerSearchCountries = countries;
	},
	setCustomerSortType(state: any, newSortType: any) {
		state.customerSortingType = newSortType;
	},
	setCustomerLoading(state: any, isLoading: any) {
		state.isLoadingCustomers = isLoading;
	},
	setCustomerLastSearchTerm(state: any, lastSearchTerm: any) {
		state.customerLastSearchTerm = lastSearchTerm;
	},
	setHasMoreCustomersToLoad(state: any, hasMoreToLoad: any) {
		state.hasMoreCustomersToLoad = hasMoreToLoad;
	},
	setCustomerVolltextSuche(state: any, isVolltext: any) {
		state.customerVolltextSuche = isVolltext;
	},
	setDetailCustomerInfo(state: any, customerInfo: CustomerInfoDto) {
		state.detailCustomerInfo = customerInfo;
	},
	setDetailCustomerDetails(state: any, customerDetails: CustomerInfoDto) {
		state.detailCustomerDetails = customerDetails;
	},
	setTotalCustomerCount(state: any, count: number) {
		state.totalCustomerCount = count;
	},

	// **********************************************************************
	// ORDERS
	// **********************************************************************
	setOrderSorting(state: any, newType: any) {
		state.orderSortingType = newType;
	},
	setOrderSuchbegriff(state: any, suchbegriff: string) {
		state.orderSuchbegriff = suchbegriff;
	},
	setOrderCancellations(state: any, cancellations: any) {
		state.orderCancellations = cancellations;
	},
	addOrUpdateOrderCancellations(state: any, cancellations: any) {
		if (state.orderCancellations === null) {
			state.orderCancellations = [];
		}
		cancellations.forEach((c: any) => {
			const cancellationIndex = state.orderCancellations.findIndex(
				(cancellation: any) => cancellation.blexonOrderId == c.blexonOrderId
			);
			if (cancellationIndex >= 0) {
				state.orderCancellations.splice(cancellationIndex, 1, c);
			} else {
				state.orderCancellations.push(c);
			}
		});
	},
	setOrderFilterStates(state: any, states: any) {
		state.orderFilterStates = states;
	},
	setOrderFilterFertiger(state: any, fertiger: any) {
		state.orderFilterFertiger = fertiger;
	},

	// **********************************************************************
	// ARTICLES
	// **********************************************************************
	setArticles(state: any, articles: ArticleDto[]) {
		state.articles = articles;
	},
	removeArticle(state: any, articleId: number) {
		const article = state.articles.find((a: ArticleDto) => a.articleId == articleId);
		if (article != undefined) {
			const index = state.articles.indexOf(article);
			if (index >= 0) {
				state.articles.splice(index, 1);
			}
		}
	},
	replaceArticle(state: any, article: ArticleDto) {
		const articleInStore = state.articles.find(
			(a: ArticleDto) => a.articleId == article.articleId
		);
		if (articleInStore != undefined) {
			const index = state.articles.indexOf(articleInStore);
			if (index >= 0) {
				if (
					article.parentArticleId != null &&
					article.parentArticleId > 0 &&
					articleInStore.parentArticleId == null
				) {
					// Sonderfall. Der Artikel ist eigentlich ein Subartikel, aber der Artikel in unserem Store
					// hat keinen Parent. Dann ist das wahrschein der einzige Artikel aus einer Baugruppe mit Einpressungen
					article.parentArticleId = null;
				}
				state.articles.splice(index, 1, article);
			}
		}
	},
	replaceAssemblyBySubarticle(state: any, assembly: ArticleDto) {
		const parentIndex = state.articles.findIndex(
			(a: ArticleDto) => a.articleId === assembly.articleId
		);
		const subArticleId = assembly.subArticleIds[0];

		const subIndex = state.articles.findIndex((a: ArticleDto) => a.articleId === subArticleId);

		if (parentIndex === -1 || subIndex === -1) return;

		const subArticle = state.articles[subIndex];

		// Parent ersetzen
		state.articles[parentIndex] = subArticle;
		// Dann Sub entfernen
		state.articles.splice(subIndex, 1);

		// Einblenden im Dashboard
		subArticle.parentArticleId = null;
	},
	addOrUpdateArticles(state: any, articles: any) {
		// Add new articles that weren't in the list before
		// Replace already existing articles to keep them updated
		articles.forEach((a: ArticleDto) => {
			const articleIndex = state.articles.findIndex(
				(stateArticle: ArticleDto) => stateArticle.articleId == a.articleId
			);
			if (articleIndex >= 0) {
				state.articles.splice(articleIndex, 1, a);
			} else {
				state.articles.push(a);
			}
		});
	},
	setValidationProgress(state: any, data: any) {
		const validationIndex = state.validationProgresses.findIndex(
			(a: any) => a.articleId == data.articleId
		);
		if (validationIndex >= 0) {
			if (data.stepProgresses && data.stepProgresses.length > 0) {
				// Update the already existing validation progress
				state.validationProgresses.splice(validationIndex, 1, data);
			} else {
				// Remove validation progress if there are no steps.
				state.validationProgresses.splice(validationIndex, 1);
			}
		} else if (data.stepProgresses && data.stepProgresses.length > 0) {
			// Add validation progress if it doesn't already exist for this article.
			state.validationProgresses.push(data);
		}
	},
	setReloadArticles(state: any, value: boolean) {
		state.reloadArticles = value;
	},
	setArticleScrollPosition(state: any, value: any) {
		state.articleScrollPosition = value;
	},
	// Deletes the price lists of the given articles
	// so that they have to be reloaded the next time they're requested.
	removeArticlePriceLists(state: any, articleIds: number[]) {
		console.log(articleIds);
		articleIds.forEach((id: number) => {
			const articleIndex = state.articles.findIndex(
				(stateArticle: ArticleDto) => stateArticle.articleId == id
			);
			if (articleIndex >= 0) {
				console.log(`resetting price lists for article ${id}`);
				state.articles[articleIndex].priceLists = [];
			}
		});
	},

	// **********************************************************************
	// ACCOUNTING
	// **********************************************************************
	setActiveAccountingTab(state: any, tab: number) {
		state.activeAccountingTab = tab;
	},

	// **********************************************************************
	// TRANSAKTIONEN
	// **********************************************************************
	setTransactions(state: any, transactions: any) {
		state.transactions = transactions;
	},
	setMatchedInvoices(state: any, invoices: any) {
		state.matchedInvoices = invoices;
	},
	removeTransaction(state: any, id: any) {
		state.transactions.splice(
			state.transactions.findIndex((i: any) => i.id === id),
			1
		);
		state.matchedInvoices = state.matchedInvoices.filter((i: any) => i.transactionId !== id);
	},
	addTransactionMatch(state: any, data: any) {
		let newInvoice = {
			transactionId: data.transactionId,
			invoiceId: data.invoice.invoiceId,
			customerId: data.invoice.customerId,
			amount: data.invoice.totalAmount,
			name: `${data.invoice.companyName} - ${data.invoice.firstname} ${data.invoice.lastname}`,
			kundenauftragId: data.invoice.orderId,
			dueDate: data.invoice.dueDate,
			matchingType: MatchingType.ByHand,
			payments: data.invoice.payments,
		};
		state.matchedInvoices.push(newInvoice);
	},
	removeTransactionMatch(state: any, invoiceId: any) {
		let index = state.matchedInvoices.findIndex((i: any) => i.invoiceId === invoiceId);
		if (index >= 0) {
			state.matchedInvoices.splice(index, 1);
		}
	},
	setMatchSelectMode(state: any, data: any) {
		let index = state.transactions.findIndex((i: any) => i.id === data.transactionId);
		state.transactions[index].isMatchSelectMode = data.isSelectMode;
	},
	setDueInvoiceSearchTerm(state: any, searchTerm: any) {
		state.dueInvoiceSearchTerm = searchTerm;
	},
	setDueInvoices(state: any, invoices: any) {
		state.dueInvoices = invoices;
	},
	setDueInvoiceSorting(state: any, invoiceSorting: any) {
		state.dueInvoiceSorting = invoiceSorting;
	},
	removeDueInvoice(state: any, invoiceId: any) {
		state.dueInvoices.splice(
			state.dueInvoices.findIndex((i: any) => i.invoiceId === invoiceId),
			1
		);
	},
	setDueInvoiceAsGemahnt(state: any, invoiceId: any) {
		let index = state.dueInvoices.findIndex((i: any) => i.invoiceId === invoiceId);
		if (index >= 0) {
			state.dueInvoices[index].hasMahnung = true;
		}
	},

	// **********************************************************************
	// RECHNUNGEN
	// **********************************************************************
	setInvoiceSearchTerm(state: any, searchTerm: any) {
		state.invoiceSearchTerm = searchTerm;
	},
	setInvoiceLastSearchTerm(state: any, searchTerm: any) {
		state.invoiceLastSearchTerm = searchTerm;
	},
	setInvoiceCustomerNumber(state: any, customerNumber: any) {
		state.invoiceCustomerNumber = customerNumber;
	},
	setInvoiceLastCustomerNumber(state: any, customerNumber: any) {
		state.invoiceLastCustomerNumber = customerNumber;
	},
	setInvoices(state: any, invoices: any) {
		state.invoices = invoices;
	},
	setInvoiceSorting(state: any, invoiceSorting: any) {
		state.invoiceSortingType = invoiceSorting;
	},
	setInvoiceFilterRegions(state: any, regions: any) {
		state.invoiceFilterRegions = regions;
	},
	addOrUpdateInvoices(state: any, invoices: any) {
		// Add new invoices that weren't in the list before
		// Replace already existing invoices to keep them updated
		invoices.forEach((i: any) => {
			const invoiceIndex = state.invoices.findIndex(
				(stateInvoice: InvoiceManagementDto) => stateInvoice.invoiceId == i.invoiceId
			);
			if (invoiceIndex >= 0) {
				state.invoices.splice(invoiceIndex, 1, i);
			} else {
				state.invoices.push(i);
			}
		});
	},

	// **********************************************************************
	// ZAHLUNGEN
	// **********************************************************************
	setPayments(state: any, payments: any) {
		state.payments = payments;
	},
	setPaymentSearchTerm(state: any, searchTerm: any) {
		state.paymentSearchTerm = searchTerm;
	},
	setPaymentLastSearchTerm(state: any, searchTerm: any) {
		state.paymentLastSearchTerm = searchTerm;
	},
	setPaymentSorting(state: any, paymentSorting: any) {
		state.paymentSorting = paymentSorting;
	},
	setPaymentFilterRegions(state: any, regions: any) {
		state.paymentFilterRegions = regions;
	},
	addOrUpdatePayments(state: any, payments: any) {
		// Add new payments that weren't in the list before
		// Replace already existing payments to keep them updated
		payments.forEach((p: any) => {
			const paymentIndex = state.payments.findIndex(
				(statePayment: PaymentDto) => statePayment.id == p.id
			);
			if (paymentIndex >= 0) {
				state.payments.splice(paymentIndex, 1, p);
			} else {
				state.payments.push(p);
			}
		});
	},

	// **********************************************************************
	// MAHNUNGEN
	// **********************************************************************
	setMahnungSearchTerm(state: any, searchTerm: any) {
		state.mahnungSearchTerm = searchTerm;
	},
	setMahnungLastSearchTerm(state: any, searchTerm: any) {
		state.mahnungLastSearchTerm = searchTerm;
	},
	setMahnungen(state: any, mahnungen: any) {
		state.mahnungen = mahnungen;
	},
	setMahnungSorting(state: any, mahnungSorting: any) {
		state.mahnungSorting = mahnungSorting;
	},
	setSelectedMahnung(state: any, dataObject: any) {
		state.mahnungen.filter((m: any) => m.mahnungsId === dataObject.mahnungsId)[0].selected =
			dataObject.value;
	},

	// **********************************************************************
	// TICKET
	// **********************************************************************
	setShowResolved(state: any, showResolved: boolean) {
		state.ticketSettings.showResolved = showResolved;
	},
};
